(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["babamonkey-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-bm-product]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const mainImage = root.querySelector('[data-bm-main-image]');
    const buttons = [...root.querySelectorAll('[data-bm-media-button]')];
    const modelButtons = [...root.querySelectorAll('[data-bm-model-button]')];
    // The thumbnail button also carries a model ID. Limit this collection to
    // the actual model stage so switching back to an image never hides its 3D
    // thumbnail.
    const modelSlots = [...root.querySelectorAll('.bm-product__model[data-bm-model-id]')];
    const select = root.querySelector('[data-bm-variant-select]');
    const price = root.querySelector('[data-bm-price]');
    const normaliseEnglishVariantLabels = () => {
      if (root.dataset.bmLocale !== 'en' || !select) return;
      select.querySelectorAll('option').forEach((option) => {
        option.textContent = option.textContent
          .replace(/\d+个\/盒\s*\(Box of (\d+)\)/g, 'Box of $1')
          .replace(/[\u3400-\u9fff]+\s*\(([^()]+)\)/g, '$1')
          .replace(/\(雪人\)/g, 'Snowman')
          .replace(/\(圣诞老人\)/g, 'Santa')
          .replace(/\s{2,}/g, ' ')
          .trim();
      });
    };
    const normaliseLegacySpecificationTables = () => {
      const formatCell = (html) => {
        if (/\*{2,}\s*g\/pc\s*g\b|(?:^|>)\s*g\/pc\s*g\b/i.test(html)) return '—';
        return html
          .replace(/(\d+(?:\.\d+)?)g\/pc\s*g\b/gi, '$1 g')
          .replace(/(\d+(?:\.\d+)?)g\s+g\b/gi, '$1 g');
      };
      root.querySelectorAll('.bm-product__description table').forEach((table) => {
        if (table.querySelector('thead') || table.dataset.bmNormalised === 'true') return;
        const sourceRows = [...table.querySelectorAll('tr')]
          .map((row) => [...row.children].filter((cell) => cell.tagName === 'TD'))
          .filter((cells) => cells.length > 1);
        if (!sourceRows.length) return;
        const headings = [];
        const records = sourceRows.map((cells) => {
          const record = {};
          for (let index = 0; index < cells.length; index += 2) {
            const heading = cells[index].textContent.trim();
            if (!heading) continue;
            if (!headings.includes(heading)) headings.push(heading);
            record[heading] = formatCell(cells[index + 1]?.innerHTML || '—');
          }
          return record;
        });
        if (!headings.length) return;
        const head = document.createElement('thead');
        const headRow = document.createElement('tr');
        headings.forEach((heading) => {
          const cell = document.createElement('th');
          cell.scope = 'col';
          cell.textContent = heading;
          headRow.append(cell);
        });
        head.append(headRow);
        const body = document.createElement('tbody');
        records.forEach((record) => {
          const row = document.createElement('tr');
          headings.forEach((heading) => {
            const cell = document.createElement('td');
            cell.innerHTML = record[heading] || '—';
            row.append(cell);
          });
          body.append(row);
        });
        table.replaceChildren(head, body);
        table.dataset.bmNormalised = 'true';
      });
    };
    const removeFactoryReferenceColumns = () => {
      root.querySelectorAll('.bm-product__description table').forEach((table) => {
        const headerCells = [...table.querySelectorAll('thead th')];
        const priceColumn = headerCells.findIndex((cell) => /出厂参考价|factory\s+reference/i.test(cell.textContent));
        if (priceColumn < 0) return;
        headerCells[priceColumn].remove();
        table.querySelectorAll('tbody tr').forEach((row) => row.children[priceColumn]?.remove());
      });
    };
    const removeImportedDraftNotice = () => {
      root.querySelectorAll('.bm-product__description p, .bm-product__description div').forEach((node) => {
        if (/当前页面为资料导入草稿|This is an imported draft/i.test(node.textContent)) node.remove();
      });
    };
    const localiseEnglishDescription = () => {
      if (root.dataset.bmLocale !== 'en') return;
      const translations = new Map([
        ['产品尺寸', 'Size'], ['单品重量', 'Unit weight'], ['外壳材质', 'Material'], ['填充物或工艺', 'Filling or process'],
        ['特点', 'Features'], ['包装', 'Packing'], ['展示盒', 'Display box'], ['整箱尺寸', 'Carton size'], ['毛重', 'Gross weight'],
        ['套装数量', 'Set quantity'], ['产品系列', 'Collection'], ['材质', 'Material'], ['规格与 SKU', 'Specifications & SKUs'],
        ['常规', 'Regular'], ['脆皮', 'Crispy shell'], ['凡士林', 'Vaseline'], ['麦芽糖', 'Maltose'], ['面粉', 'Flour'],
        ['积木', 'Building block'], ['冰沙', 'Slush'], ['流体玻璃', 'Liquid glass'], ['透明', 'Transparent'], ['实色', 'Solid'],
        ['水果宝宝系列', 'Fruit Baby Series'], ['水果系列', 'Fruit Series'], ['动物系列', 'Animal Series'], ['人物系列', 'Character Series'],
        ['钞票系列', 'Banknote Series'], ['食品系列（深加工）', 'Food Series'], ['食品系列', 'Food Series'], ['蔬菜系列', 'Vegetable Series'],
        ['高透，不粘手，慢回弹', 'Highly transparent, non-sticky, slow rebound'], ['高透、不粘手、慢回弹', 'Highly transparent, non-sticky, slow rebound'],
        ['高透，不粘手，高回弹', 'Highly transparent, non-sticky, high rebound'], ['不粘手，快回弹', 'Non-sticky, fast rebound'],
        ['不粘手，弱回弹', 'Non-sticky, gentle rebound'], ['搞怪表情，不粘手，快回弹', 'Playful expression, non-sticky, fast rebound'], ['多色，不粘手，快回弹', 'Multicolor, non-sticky, fast rebound'],
        ['PU慢回弹', 'PU slow rebound'], ['特制薄脆壳、PU慢回弹', 'Special crisp shell, PU slow rebound'],
        ['一箱20盒', '20 display boxes/carton'], ['一箱40盒', '40 display boxes/carton']
      ]);
      const replaceText = (value) => {
        let output = value.replace(/[\u3400-\u9fff（）()、，：\s]+\s*\/\s*(?=[A-Za-z])/g, '');
        translations.forEach((english, chinese) => { output = output.split(chinese).join(english); });
        output = output.replace(/一箱\s*(\d+)\s*盒/g, '$1 display boxes/carton');
        output = output.replace(/(\d+)\s*pcs?\s*\/\s*盒/g, '$1 pcs/box');
        output = output.replace(/\b([A-Za-z][A-Za-z ]+?)\s*\(\1\)/gi, '$1');
        return output.replace(/\s{2,}/g, ' ').trim();
      };
      const description = root.querySelector('.bm-product__description');
      // Imported product copy often has a full Chinese sentence followed by an
      // English translation. On English storefronts show the complete English
      // half instead of leaving a size number or a Chinese prefix behind.
      description.querySelectorAll('h2, h3, p, li').forEach((element) => {
        const source = element.textContent.trim();
        const bilingual = source.match(/^.+?\s*\/\s*([A-Za-z][\s\S]*)$/);
        if (bilingual) element.textContent = bilingual[1].trim();
      });
      const walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((node) => { node.nodeValue = replaceText(node.nodeValue); });
    };
    normaliseLegacySpecificationTables();
    removeFactoryReferenceColumns();
    removeImportedDraftNotice();
    localiseEnglishDescription();
    normaliseEnglishVariantLabels();
    const hideModels = () => {
      modelSlots.forEach((slot) => {
        slot.hidden = true;
        slot.querySelector('model-viewer')?.pause?.();
      });
    };
    const activateMedia = (button) => {
      if (!mainImage) return;
      mainImage.classList.remove('is-hidden');
      hideModels();
      mainImage.src = button.dataset.bmSrc;
      mainImage.srcset = button.dataset.bmSrcset;
      mainImage.alt = button.dataset.bmAlt;
      buttons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', active ? 'true' : 'false');
      });
      modelButtons.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-current', 'false');
      });
    };
    const activateModel = (button) => {
      const slot = modelSlots.find((item) => item.dataset.bmModelId === button.dataset.bmModelId);
      if (!slot || !mainImage) return;
      mainImage.classList.add('is-hidden');
      hideModels();
      slot.hidden = false;
      buttons.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-current', 'false');
      });
      modelButtons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', active ? 'true' : 'false');
      });
      const viewer = slot.querySelector('model-viewer');
      if (viewer && window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: () => {} }]);
      }
    };
    buttons.forEach((button) => button.addEventListener('click', () => activateMedia(button)));
    modelButtons.forEach((button) => button.addEventListener('click', () => activateModel(button)));
    root.querySelectorAll('[data-bm-model-action]').forEach((control) => {
      control.addEventListener('click', () => {
        const viewer = control.closest('[data-bm-model-id]')?.querySelector('model-viewer');
        if (!viewer) return;
        switch (control.dataset.bmModelAction) {
          case 'zoom-in':
            viewer.fieldOfView = '24deg';
            break;
          case 'zoom-out':
            viewer.fieldOfView = '48deg';
            break;
          case 'fullscreen':
            viewer.requestFullscreen?.();
            break;
          default:
            viewer.cameraOrbit = '0deg 75deg 105%';
            viewer.fieldOfView = 'auto';
            viewer.jumpCameraToGoal?.();
        }
      });
    });
    select?.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (price && option.dataset.bmPrice) price.textContent = option.dataset.bmPrice;
      if (option.dataset.bmMediaId) {
        const variantImage = buttons.find((button) => button.dataset.bmMediaId === option.dataset.bmMediaId);
        if (variantImage) activateMedia(variantImage);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
